export default __webpack_public_path__ + "static/media/StakeLogic.e4e3084f.jpg";